import { AdaState } from '@core/ada/store/states/ada.state';

export const adaState = [AdaState];
